import { getState } from '~src/state';

export const isPositiveFiniteNumber = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue > 0;
};

const getPositiveNumber = (...values) => {
  const value = values.find(isPositiveFiniteNumber);
  return value === undefined ? undefined : Number(value);
};

export const formatHasOwnDimensions = (format) =>
  isPositiveFiniteNumber(format?.width) &&
  isPositiveFiniteNumber(format?.height);

export const calculateFormat = () => {
  let formatId;
  let formatWidth;
  let formatHeight;

  const format = getState('selected.formato');
  const formatDefault = getState('selected.formatoDefault');

  if (format && format.objectId) {
    formatId = format.objectId;
    formatWidth = getPositiveNumber(
      format.width,
      format.editor_project_formats_default_pointer?.width,
      formatDefault?.width
    );
    formatHeight = getPositiveNumber(
      format.height,
      format.editor_project_formats_default_pointer?.height,
      formatDefault?.height
    );
  } else {
    formatId = formatDefault.objectId;
    formatWidth = getPositiveNumber(formatDefault.width);
    formatHeight = getPositiveNumber(formatDefault.height);
  }

  return {
    formatId,
    formatWidth,
    formatHeight,
  };
};

export const calculateFormatDpi = (source, fallbackDpi) => {
  const format = source?.editor_project_formats_pointer;
  const formatDefault = source?.editor_project_formats_default_pointer;
  const hasCustomDimensions = formatHasOwnDimensions(format);

  return getPositiveNumber(
    hasCustomDimensions ? format?.dpi : undefined,
    format?.editor_project_formats_default_pointer?.dpi,
    formatDefault?.dpi,
    fallbackDpi
  );
};

export const calculateFormatOrientation = (source) => {
  const format = source?.editor_project_formats_pointer;
  const formatDefault = source?.editor_project_formats_default_pointer;
  const hasCustomDimensions = formatHasOwnDimensions(format);

  return (
    (hasCustomDimensions ? format?.orientation : undefined) ||
    format?.editor_project_formats_default_pointer?.orientation ||
    formatDefault?.orientation ||
    formatDefault?.editor_project_formats_default_pointer?.orientation
  );
};
